import YoungPersonMoveRoomView from './YoungPersonMoveRoomView';

export default YoungPersonMoveRoomView;
